"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _antd = require("antd");
var _tokenMeta = _interopRequireDefault(require("antd/lib/version/token-meta.json"));
var _token2 = _interopRequireDefault(require("antd/lib/version/token.json"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _useDebouncy = require("use-debouncy");
var _componentPanel = require("../component-panel");
var _locale = require("../locale");
var _components = _interopRequireDefault(require("../previews/components"));
var _deepUpdateObj = _interopRequireDefault(require("../utils/deepUpdateObj"));
var _getDesignToken = _interopRequireDefault(require("../utils/getDesignToken"));
var _getValueByPath = _interopRequireDefault(require("../utils/getValueByPath"));
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var _DemoCard = _interopRequireDefault(require("./DemoCard"));
var _DemoWrapper = _interopRequireDefault(require("./DemoWrapper"));
var _TokenItem = _interopRequireDefault(require("./TokenItem"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var useStyle = (0, _makeStyle.default)('ComponentTokenEditor', function (token) {
  return (0, _defineProperty2.default)({}, token.componentCls, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    display: 'flex',
    height: '100%',
    width: '100%'
  }, "".concat(token.componentCls, "-menu"), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(token.rootCls, "-menu-item-group-title"), {
    paddingLeft: 28,
    marginBlock: 16,
    fontSize: 13,
    '&::after': {
      position: 'relative',
      top: 12,
      display: 'block',
      width: 'calc(100% - 20px)',
      height: 1,
      background: token.colorSplit,
      content: '""'
    }
  }), "".concat(token.componentCls, "-menu-component-sub"), {
    fontSize: 12,
    marginLeft: 8,
    fontWeight: 'normal'
  })), "".concat(token.componentCls, "-demo"), (0, _defineProperty2.default)({
    flex: 1,
    width: 0,
    background: token.colorBgLayout,
    display: 'flex',
    flexDirection: 'column'
  }, "".concat(token.componentCls, "-demo-banner"), {
    padding: '28px 24px 24px',
    flex: 'none',
    background: token.colorBgContainer,
    borderBottom: "1px solid ".concat(token.colorSplit),
    '&-title': {
      fontSize: token.fontSizeHeading3,
      lineHeight: token.lineHeightHeading3,
      color: token.colorTextHeading
    },
    '&-info': {
      fontSize: token.fontSize,
      lineHeight: token.lineHeight,
      color: token.colorTextSecondary,
      marginLeft: 12
    }
  })), "".concat(token.componentCls, "-token-panel"), (0, _defineProperty2.default)({
    flex: '0 0 400px',
    height: '100%',
    background: token.colorBgContainer,
    borderLeft: "1px solid ".concat(token.colorSplit),
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '&-block': {
      padding: '16px 6px',
      '&:not(:last-child)': {
        borderBottom: "1px solid ".concat(token.colorSplit)
      }
    },
    '&-subtitle': {
      fontSize: token.fontSizeSM,
      lineHeight: token.lineHeightSM,
      fontWeight: token.fontWeightStrong,
      marginBottom: 12,
      marginLeft: 8,
      color: token.colorText
    }
  }, "&-anchor".concat(token.rootCls, "-anchor-wrapper"), (0, _defineProperty2.default)({
    padding: '0px 16px'
  }, "".concat(token.rootCls, "-anchor"), {
    padding: '10px 0'
  }))));
});
var getTokenCount = function getTokenCount(component) {
  // @ts-ignore
  var componentStatistic = _token2.default[component];
  var globalCount = (componentStatistic === null || componentStatistic === void 0 ? void 0 : componentStatistic.global.length) || 0;
  var componentCount = Object.keys((componentStatistic === null || componentStatistic === void 0 ? void 0 : componentStatistic.component) || {}).length || 0;
  return {
    total: globalCount + componentCount,
    global: globalCount,
    component: componentCount
  };
};
var classifyTokens = function classifyTokens(tokens) {
  var result = {
    color: [],
    size: [],
    style: []
  };
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (['color', 'bg'].some(function (key) {
        return token.toLocaleLowerCase().includes(key);
      }) || token.toLocaleLowerCase().endsWith('outline')) {
        result.color.push(token);
      } else if (['size', 'margin', 'padding', 'height', 'width'].some(function (key) {
        return token.toLocaleLowerCase().includes(key);
      })) {
        result.size.push(token);
      } else {
        result.style.push(token);
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  result.color.sort();
  result.size.sort();
  result.style.sort();
  return result;
};
var ComponentTokenEditor = function ComponentTokenEditor(_ref2) {
  var theme = _ref2.theme;
  var locale = (0, _locale.useLocale)();
  var prefixCls = "antd-component-token-editor";
  var _useState = (0, _react.useState)('Button'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    activeComponent = _useState2[0],
    setActiveComponent = _useState2[1];
  var tokenPanelRef = (0, _react.useRef)(null);
  var _useStyle = useStyle(prefixCls),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    hashId = _useStyle2[1];
  var count = (0, _react.useMemo)(function () {
    return getTokenCount(activeComponent);
  }, [activeComponent]);
  var tokenGroups = (0, _react.useMemo)(function () {
    var _activeComponent, _activeComponent2;
    var globalTokens = ((_activeComponent = _token2.default[activeComponent]) === null || _activeComponent === void 0 ? void 0 : _activeComponent.global) || [];
    var componentTokens = Object.keys(((_activeComponent2 = _token2.default[activeComponent]) === null || _activeComponent2 === void 0 ? void 0 : _activeComponent2.component) || {});
    return {
      global: classifyTokens(globalTokens),
      component: classifyTokens(componentTokens)
    };
  }, [activeComponent]);
  var _useState3 = (0, _react.useState)(!!(0, _getValueByPath.default)(theme.config, ['components', activeComponent, 'algorithm'])),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    enableAlgorithm = _useState4[0],
    setEnableAlgorithm = _useState4[1];
  var debouncedAlgorithmChange = (0, _useDebouncy.useDebouncyFn)(function (checked) {
    var _theme$onThemeChange;
    (_theme$onThemeChange = theme.onThemeChange) === null || _theme$onThemeChange === void 0 || _theme$onThemeChange.call(theme, (0, _deepUpdateObj.default)(theme.config, ['components', activeComponent, 'algorithm'], checked || undefined), ['components', activeComponent, 'algorithm']);
  }, 500);
  var handleAlgorithmChange = function handleAlgorithmChange(checked) {
    setEnableAlgorithm(checked);
    debouncedAlgorithmChange(checked);
  };
  var menuItems = (0, _react.useMemo)(function () {
    return Object.entries(_componentPanel.antdComponents).map(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      return {
        key: key,
        label: locale.components[key],
        type: 'group',
        children: value.map(function (item) {
          return {
            key: item,
            label: /*#__PURE__*/_react.default.createElement("span", null, item, locale._lang === 'zh-CN' && /*#__PURE__*/_react.default.createElement("span", {
              className: "".concat(prefixCls, "-menu-component-sub")
            }, locale.components[item]))
          };
        })
      };
    });
  }, [locale]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(prefixCls, hashId)
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: '0 0 258px',
      height: '100%',
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    className: "".concat(prefixCls, "-menu"),
    items: menuItems,
    selectedKeys: [activeComponent],
    onSelect: function onSelect(_ref5) {
      var key = _ref5.key;
      setActiveComponent(key);
    },
    style: {
      width: '100%'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-demo")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-demo-banner")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-demo-banner-title")
  }, activeComponent, locale._lang === 'zh-CN' && /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginLeft: 12
    }
  }, locale.components[activeComponent]), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-demo-banner-info")
  }, locale.demo.tokenCount(count.total, count.global, count.component)))), /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    theme: _objectSpread(_objectSpread({}, theme.config), {}, {
      inherit: false
    })
  }, /*#__PURE__*/_react.default.createElement(_DemoWrapper.default, null, _components.default[activeComponent].map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_DemoCard.default, {
      demo: item,
      key: item.key
    });
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-token-panel")
  }, /*#__PURE__*/_react.default.createElement(_antd.Anchor, {
    affix: false,
    getContainer: function getContainer() {
      return tokenPanelRef.current;
    },
    className: "".concat(prefixCls, "-token-panel-anchor"),
    direction: "horizontal",
    items: [{
      title: locale.color,
      href: '#component-color',
      key: 'color'
    }, {
      title: locale.size,
      href: '#component-size',
      key: 'size'
    }, {
      title: locale.style,
      href: '#component-style',
      key: 'style'
    }]
  }), /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
    title: locale.componentAlgorithm,
    placement: "bottom",
    mouseEnterDelay: 0.2
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      top: 14,
      right: 12,
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "component-algorithm",
    style: {
      fontSize: 12,
      marginRight: 4,
      cursor: 'pointer'
    }
  }, locale.enableComponentAlgorithm), /*#__PURE__*/_react.default.createElement(_antd.Switch, {
    id: "component-algorithm",
    checked: enableAlgorithm,
    size: "small",
    onChange: handleAlgorithmChange
  }))), /*#__PURE__*/_react.default.createElement("div", {
    ref: tokenPanelRef,
    style: {
      flex: 1,
      height: 0,
      overflow: 'auto'
    }
  }, ['color', 'size', 'style'].map(function (key) {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "component-".concat(key),
      className: "".concat(prefixCls, "-token-panel-block"),
      key: key
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "-token-panel-subtitle")
    }, locale[key]), tokenGroups.component[key].filter(function (token) {
      return _tokenMeta.default.components[activeComponent].some(function (meta) {
        return meta.token === token;
      });
    }).map(function (token) {
      var _activeComponent$find;
      var configValue = (0, _getValueByPath.default)(theme.config, ['components', activeComponent, token]);
      var value = configValue !== null && configValue !== void 0 ? configValue : _token2.default[activeComponent].component[token];
      return /*#__PURE__*/_react.default.createElement(_TokenItem.default, {
        key: token,
        token: token,
        theme: theme,
        value: value,
        configValue: configValue,
        component: activeComponent,
        color: key === 'color',
        tooltip: (_activeComponent$find = _tokenMeta.default.components[activeComponent].find(function (meta) {
          return meta.token === token;
        })) === null || _activeComponent$find === void 0 ? void 0 : _activeComponent$find[locale._lang === 'zh-CN' ? 'desc' : 'descEN'],
        prefix: /*#__PURE__*/_react.default.createElement("span", {
          className: "".concat(prefixCls, "-token-item-tag")
        }, locale.component)
      });
    }), tokenGroups.global[key].map(function (token) {
      var _token;
      var configValue = (0, _getValueByPath.default)(theme.config, ['components', activeComponent, token]);
      var value = configValue !== null && configValue !== void 0 ? configValue : (0, _getDesignToken.default)(theme.config)[token];
      return /*#__PURE__*/_react.default.createElement(_TokenItem.default, {
        key: token,
        token: token,
        theme: theme,
        value: value,
        tooltip: (_token = _tokenMeta.default.global[token]) === null || _token === void 0 ? void 0 : _token[locale._lang === 'zh-CN' ? 'desc' : 'descEn'],
        configValue: configValue,
        component: activeComponent,
        color: key === 'color'
      });
    }), !tokenGroups.component[key].length && !tokenGroups.global[key].length && /*#__PURE__*/_react.default.createElement(_antd.Empty, {
      image: _antd.Empty.PRESENTED_IMAGE_SIMPLE,
      description: "\u6682\u65E0\u76F8\u5173 Token"
    }));
  }))));
};
var _default = exports.default = ComponentTokenEditor;